// extracted by mini-css-extract-plugin
export default {"dual-slider":"+BKATTN-Vc1ZZYeScHGbbg==","slider":"_80oZIXBxOttj5d3OjZFzQw=="};